import FieldBase from './FieldBase'

export default class extends FieldBase {
  constructor({ childAttrs, oneLine = false, ...args }) {
    super(args)
    let child
    if (oneLine) {
      child = this.getComponentWithVModel('one-line-wysiwyg-input')
    } else {
      child = this.getComponentWithVModel('wysiwyg-input')
    }
    child.attrs = {
      ...child.attrs,
      ...childAttrs
    }
    this.children = [child]
  }
}
